<template>
  <section class="requests-list">
    <SpaceDescription>
      <Headline :size="1">Activation Requests</Headline>
    </SpaceDescription>

    <ActivationsPopup
      v-if="showPopup"
      :activation="activationModel"
      @closePopup="onClose"
    />

    <ActivationsTable
      @activationUpdate="onUpdate"
    />
  </section>
</template>

<script>
import SpaceDescription from '@/components/SpaceDescription/SpaceDescription.component';
import Headline from '@/components/Headline/Headline.component';
import ActivationsTable from '@/components/Table/tables/ActivationsTable.component';
import RouterNames from "@/router/route.names";
import {ActivationModel} from "@/classes/models/Activation.model";
import ActivationsPopup from "@/components/Popup/ActivationsPopup.component.vue";

export default {
  name: "RequestsList",
  components: {
    ActivationsPopup,
    SpaceDescription,
    Headline,
    ActivationsTable
  },
  computed: {
    permissions() {return this.$store.getters['user/permissions']}
  },
  watch: {
    permissions() {this.checkPermissions()}
  },
  created() {
    this.checkPermissions();
    this.$store.dispatch('event/getMatchDays')
  },
  data: () => ({
    activationModel: new ActivationModel(),
    showPopup: false,
  }),
  methods: {
    checkPermissions() {
      const permitted = this.$store.getters['user/haveAccessToActivations'];
      if (!permitted) this.$router.push({name: RouterNames.Home})
    },
    onUpdate(model) {
      this.activationModel = model
      this.showPopup = true
    },
    onClose() {
      this.showPopup = false;
      this.$store.dispatch('sponsorActivationsList/getActivations')
    },
  }
}
</script>


<style lang="scss">
.requests-list {
   &__filters {
     display: flex;
     justify-content: space-between;
     margin-bottom: 30px;

     &-input-wrapper, &-btn-wrapper {
       display: flex;
       > .InputDropdown:first-child {
         margin-right: 30px;
       }
       > .button-component:first-child {
         margin-right: 30px;
       }
     }
   }
}
</style>
